import React from "react";

const CheckMark = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.00019 12.1717L2.51486 8.68638L1.10065 10.1006L6.00019 15.0001L15.1924 5.80794L13.7782 4.39372L6.00019 12.1717Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckMark;
